const  CRTableForm =({formName
})=>{
    return(
        <div>{formName
        }</div>
    )
};

export default CRTableForm;